import React from "react";
import WspolnotaRozliczenieSeryjneTHead from "./WspolnotaRozliczenieSeryjneTHead.js";
import WspolnotaRozliczenieSeryjneTBody from "./WspolnotaRozliczenieSeryjneTBody.js";

const WspolnotaRozliczenieSeryjneTable = ( props ) => {

  const { stawki, stawkiJednorazowe, czynszeMsc, ind, udzialyKontaAkt,   
    idw, wspolnota, lokale, ulice, grupy, przelewyWspolnota, czynszeWspolnota,  
    mieszkancy, zestaw } = props;

  return (
    <div className="table-container">
      <table className="lista tabela naleznosci-seryjne">
        <WspolnotaRozliczenieSeryjneTHead 
          stawki={stawki}
          stawkiJednorazowe={stawkiJednorazowe}
          czynszeMsc={czynszeMsc}
          ind={ind}
        />
        <WspolnotaRozliczenieSeryjneTBody
          idw={idw}
          wspolnota={wspolnota}
          lokale={lokale}
          ulice={ulice}
          grupy={grupy}
          udzialyKontaAkt={udzialyKontaAkt}
          stawki={stawki}
          stawkiJednorazowe={stawkiJednorazowe}
          przelewyWspolnota={przelewyWspolnota}
          czynszeWspolnota={czynszeWspolnota}
          czynszeMsc={czynszeMsc}
          mieszkancy={mieszkancy}
          ind={ind}
          zestaw={zestaw}
        />
      </table>
    </div>
  )
}

export default WspolnotaRozliczenieSeryjneTable;